export default "__VITE_ASSET__CYHULWkJ__"